module.exports = __webpack_public_path__ + "static/media/tgle-ch-dark.3cb1e513.png";